type FeatureFlagsConfig = {
  type: 'boolean' | 'number' | 'string';
  /**
   * Used in case its not possible to get a value from the FF server
   */
  default: unknown;
};

export type SternumWebFeatureFlag = keyof typeof sternumWebFFConfig;

export const sternumWebFFConfig = {
  'show-anomalies-over-time-graph': {
    type: 'boolean',
    default: false,
  },
  'show-alerts-overview-tab': {
    type: 'boolean',
    default: false,
  },
  'enable-registration-devices-view': {
    type: 'boolean',
    default: false,
  },
  'enable-registration-compute-view': {
    type: 'boolean',
    default: false,
  },
  'enable-sandbox-view': {
    type: 'boolean',
    default: false,
  },
  'show-cloud-scanning-settings': {
    type: 'boolean',
    default: false,
  },
  'show-posture-management-settings': {
    type: 'boolean',
    default: false,
  },
  'enable-image-widget-type': {
    type: 'boolean',
    default: false,
  },
  'show-device-activity-in-anomaly-investigation': {
    type: 'boolean',
    default: false,
  },
  'show-mocked-anomalies': {
    type: 'boolean',
    default: false,
  },
} as const satisfies Record<string, FeatureFlagsConfig>;
